var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 692,
    height: 1024,
    viewBox: "0 0 692 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6845_40624",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 676,
    height: 1027
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 676,
    height: 1027,
    fill: "#002F43"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6845_40624)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6845_40624)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 676,
    height: 1027,
    fill: "#EFEDF8"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.1033 484.255C-7.57434 469.896 6.11616 460.306 20.4753 462.835L140.473 483.97C154.832 486.499 164.422 500.189 161.893 514.548L141.639 629.546C139.11 643.905 125.42 653.495 111.061 650.966L-8.9369 629.832C-23.296 627.303 -32.8862 613.612 -30.3572 599.253L-10.1033 484.255Z",
    fill: "url(#paint0_linear_6845_40624)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.925 478.995C139.921 471.961 143.997 464.633 151.031 462.628L213.143 444.925C220.177 442.92 227.505 446.997 229.509 454.031L246.475 513.555C248.48 520.589 244.403 527.916 237.369 529.921L175.257 547.625C168.223 549.629 160.896 545.552 158.891 538.518L141.925 478.995Z",
    stroke: "url(#paint1_linear_6845_40624)",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    width: 336.344,
    height: 355.87,
    rx: 32.7248,
    transform: "matrix(-0.508055 -0.861324 -0.861324 0.508055 409.237 1045.94)",
    fill: "#BCAFFC"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 421.688,
    height: 408.248,
    rx: 46.0932,
    transform: "matrix(-0.783749 -0.621077 -0.621077 0.783749 796.217 884.198)",
    fill: "url(#paint2_linear_6845_40624)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.455 985.285C544.615 952.403 517.277 926.427 484.394 927.268L164.608 935.439C131.725 936.28 105.75 963.618 106.59 996.5L114.404 1302.3C115.245 1335.18 142.583 1361.16 175.465 1360.32L495.252 1352.14C528.134 1351.3 554.11 1323.97 553.269 1291.08L545.455 985.285Z",
    fill: "url(#paint3_linear_6845_40624)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.095 725.156C342.481 720.732 340.83 715.212 336.406 712.828L293.382 689.638C288.958 687.253 283.437 688.907 281.05 693.331L258.856 734.475C256.469 738.899 258.121 744.418 262.545 746.803L305.569 769.993C309.993 772.378 315.514 770.724 317.9 766.3L340.095 725.156Z",
    fill: "#8B7CD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.612 747.066C235.559 747.253 238.099 745.017 238.286 742.07L240.101 713.415C240.287 710.469 238.05 707.928 235.103 707.74L207.695 705.995C204.748 705.808 202.208 708.044 202.021 710.991L200.206 739.646C200.02 742.592 202.258 745.133 205.205 745.321L232.612 747.066Z",
    fill: "#533EB2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6845_40624",
    x: -16,
    y: -12,
    width: 708,
    height: 1059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85 0 0 0 0 0.85 0 0 0 0 0.85 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6845_40624"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6845_40624",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6845_40624",
    x1: 39.9143,
    y1: 455.463,
    x2: 91.6215,
    y2: 658.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCAFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7EAF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6845_40624",
    x1: 158.388,
    y1: 453.891,
    x2: 230.012,
    y2: 538.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#513DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AB9E2",
    stopOpacity: 0.36
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6845_40624",
    x1: 210.844,
    y1: 0,
    x2: 210.844,
    y2: 408.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4934AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8070CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6845_40624",
    x1: 450.481,
    y1: 902.511,
    x2: 209.379,
    y2: 1385.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCAFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5945B6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLogin);
export default __webpack_public_path__ + "static/media/bg_login.22cb93cb882ac133cea455cc2b0f648e.svg";
export { ForwardRef as ReactComponent };